import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Element } from 'react-scroll';

import { Skeleton } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';

import useClasses from '../../../../../hooks/legacy/useClasses';

import styles from './RestaurantsCarousel.style';

import { getConfig } from '../../../../../AppConfig';
import { getImage, getText } from '../../../../../util/Helpers';
import MainHeroSection from './MainHeroSection';
import useDesktopCheck from '../../../../../util/hooks/UseDesktopCheck';
import CenterHeroSection from './CenterHeroSection';
import LeftHeroSection from './LeftHeroSection';
import RightHeroSection from './RightHeroSection';

const config = getConfig();

function RestaurantsCarousel() {
  const classes = useClasses(styles);
  const isDesktop = useDesktopCheck();

  const [sliderData, setSliderData] = useState([]);

  const heroSection = getText(
    config,
    'hero_section',
    config.textsPlaceholder.restaurant_hero_section
  );

  const skeleton = new Array(1)
    .fill(null)
    .map((i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        height="750px"
        className={classes.skeleton}
      />
    ));

  useEffect(() => {
    const { images } = config;
    const logoImage = images.filter(
      (img) => img.name === 'site_logo' && img.version === 1
    );

    const data = [];

    for (let i = 1; i <= 3; i++) {
      const imageKey = `${
        // eslint-disable-next-line no-nested-ternary
        i === 1 ? 'first' : i === 2 ? 'second' : 'third'
      }_slide`;
      const imageIndex = images.findIndex((item) => item.name === imageKey);
      const image = images[imageIndex];

      const titleKey = `slider_${String(i).padStart(2, '0')}_title`;
      const subKey = `slider_${String(i).padStart(2, '0')}_sub`;
      const btnKey = `slider_${String(i).padStart(2, '0')}_btn`;

      data.push({
        image: getImage(config, image?.name ?? '', ''),
        title: titleKey
          ? getText(
              config,
              titleKey,
              config.textsPlaceholder[`restaurant_${titleKey}`]
            )
          : '',
        sub: subKey
          ? getText(
              config,
              subKey,
              config.textsPlaceholder[`restaurant_${subKey}`]
            )
          : '',
        btn: btnKey
          ? getText(
              config,
              btnKey,
              config.textsPlaceholder[`restaurant_${btnKey}`]
            )
          : '',
        logo: logoImage ? getImage(config, logoImage[0]?.name, '') : '',
      });
    }
    setSliderData(data);
  }, [config]);

  return (
    <Element name="topOfHomePage">
      {sliderData?.length > 0 ? (
        <Carousel
          autoPlay
          infiniteLoop
          interval={6000}
          transitionTime={2000}
          showStatus={false}
          showArrows={false}
          swipeable={false}
          key="topOfHomePageCarousel"
        >
          {sliderData.map((restaurant) => (
            <Box
              sx={{ position: 'relative' }}
              key={`restaurant_${restaurant.title}`}
            >
              <Box
                component="img"
                sx={{ height: '750px' }}
                src={
                  restaurant.image?.includes('https')
                    ? restaurant.image
                    : `https:${restaurant.image}`
                }
                // src={`${background}?width=1300&height=530`}
                className={classes.restaurantImg}
              />
              {(!isDesktop || heroSection === 'A') && (
                <MainHeroSection restaurant={restaurant} />
              )}
              {isDesktop && heroSection === 'B' && (
                <CenterHeroSection restaurant={restaurant} />
              )}
              {isDesktop && heroSection === 'C' && (
                <LeftHeroSection restaurant={restaurant} />
              )}
              {isDesktop && heroSection === 'D' && (
                <RightHeroSection restaurant={restaurant} />
              )}
            </Box>
          ))}
        </Carousel>
      ) : (
        skeleton
      )}
    </Element>
  );
}

export default RestaurantsCarousel;
